import axios from "axios";
export const getPresignedUrlRestApi = {
    data() {
        return {
            getPresignedUrlDetails: [],
            overlay: false,
            noDataText: null,
        };
    },
    methods: {
        async getPresignedUrlRestApiMethod(s3_key, downloadFileBoolean) {
            this.overlay = true;
            const apiUrl = process.env.VUE_APP_AWS_PRESIGNED_URL_REST_API_END_POINT;
            const inputParams = {
                key: s3_key,
            };
            ////console.log("getPresignedUrlRestApiMethod inputParams", inputParams);
            try {
                const result = await axios.post(apiUrl, inputParams, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                // console.log("result of getPresignedUrlRestApiMethod", result);

                if (result.data.status === "SUCCESS") {
                    if (downloadFileBoolean) {
                        const fileName = this.getFileNameFromKey(result.data.url);
                        const res = await this.downloadFileMethod(result.data.url, fileName);
                        console.log('fileName,,,,,', fileName, res)
                    } else {
                        return result.data.url;
                    }
                }
                console.log('getPresignedUrlRestApiMethod', result)
            } catch (error) {
                //console.log("Error in getPresignedUrlRestApiMethod:", error);
                this.getPresignedUrlDetails = [];
                this.noDataText = error;
                return "ERROR";
            } finally {
                this.overlay = false;
            }
        },
        async downloadFileMethod(s3_url, fileName) {
            this.overlay = true;
            try {
                const response = await fetch(s3_url);
                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = blobUrl;
                anchor.target = "_blank";
                anchor.download = fileName;
                anchor.click();
                URL.revokeObjectURL(blobUrl);
            } catch (error) {
                this.SnackBarComponent = {
                    SnackbarVmodel: true,
                    SnackbarColor: "error",
                    Top: true,
                    SnackbarText: error,
                };
            } finally {
                this.overlay = false;
            }
        },
        getFileNameFromKey(file_path) {
            return file_path.split("/").pop().split("?")[0];
        },
        // async uploadFileWithPresigned(file, key) {
        //     try {
        //         const presignedUrl = await this.getPresignedUrlRestApiMethod(key);

        //         if (!presignedUrl || presignedUrl === "ERROR") {
        //             throw new Error("Presigned URL failed");
        //         };
        //         console.log("file",file);
        //         console.log('presignedUrl',presignedUrl)
        //         await axios.put(presignedUrl, file, {
        //             headers: {
        //                 "Content-Type": file.type,
        //             },
        //         });

        //         return presignedUrl.split("?")[0];

        //     } catch (err) {
        //         console.error(err);
        //         return "ERROR";
        //     }
        // }
    },
};
